import { render, staticRenderFns } from "./IDCard.vue?vue&type=template&id=9278cbc4&scoped=true&"
import script from "./IDCard.vue?vue&type=script&lang=js&"
export * from "./IDCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9278cbc4",
  null
  
)

export default component.exports